module.exports = __webpack_public_path__ + "img/5.7e0c0008.jpg";